import React from "react";
import {Credits} from "../components/creditloader";

const CreditPage = ()=>{
    return (
        <div className={"page"}>
            <h1 className={"creditHeader"}>Full Credits</h1>
            <Credits id="credits" />
        </div>

    );
};

export default CreditPage;